const reducer = (state = 'All', action) =>{
    switch(action.type){
        case "setCompanyTypeFilter3": 
            return action.payload;
        default: 
            return state;
    }
}

export default reducer;  